import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PageRender from "./PageRender";
import Home from "./screens/home.jsx";
import Index from "./pages/index";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "./components/shared/navbar.jsx";
import Sidebar from "./components/shared/Sidebar.jsx";

const Routers = () => {
  const location = useLocation(),
    { error, auth } = useSelector((state) => state),
    dispatch = useDispatch();
  console.log(location);

  return (
    <>
      <ToastContainer position="bottom-center" />
      <Sidebar auth={auth}>
        {auth.isAuth && (
          <>
            <Navbar />
          </>
        )}

        <Routes>
          <Route path="/" element={auth?.isAuth ? <Index /> : <Home />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route path="/:page" element={<PageRender />} />
          <Route path="/:page/:id" element={<PageRender />} />
          <Route path="/:page/:id/:step" element={<PageRender />} />
        </Routes>
      </Sidebar>
    </>
  );
};

export default Routers;
